import { uiSize } from '@utils'

function EditIcon() {
  return (
    <svg width={uiSize(13)} height={uiSize(14)} viewBox='0 0 13 14' fill='none' stroke='currentColor'>
      <path
        d='M11.0632 4.59982L6.15104 9.51209C5.87183 9.79129 5.51623 9.98161 5.12904 10.059L3.15155 10.4545L3.54705 8.47703C3.62448 8.08985 3.81479 7.73426 4.09399 7.45506L9.00619 2.54278M11.0632 4.59982L11.8989 3.76414C12.2894 3.37362 12.2894 2.74046 11.8989 2.34993L11.2561 1.70711C10.8655 1.31658 10.2324 1.31658 9.84186 1.70711L9.00619 2.54278M11.0632 4.59982L9.00619 2.54278'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path d='M1.3335 13H11.5153' strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
    </svg>
  )
}

export default EditIcon
